import React from 'react';
import { Typography } from 'fronton-react';
import { comma, subtitleViewCurrency } from './styles';
import { priceFormatter } from './utils';
import { ProductPriceViewProps } from './types';

type SubtitleViewProps = Pick<
  ProductPriceViewProps,
  'fract' | 'currency' | 'unit' | 'intPart' | 'prevPrice'
>;

export const SubtitleView: React.FC<SubtitleViewProps> = ({ fract, currency, unit, intPart }) => {
  const parts = React.useMemo(() => priceFormatter.formatToParts(parseInt(intPart, 10)), [intPart]);
  const joinedParts = React.useMemo(() => {
    const THIN_SPACE = String.fromCodePoint(8201);
    return parts.reduce((acc, item) => {
      const value = item.type === 'group' ? THIN_SPACE : item.value;
      return `${acc}${value}`;
    }, '');
  }, [parts]);

  return (
    <div data-qa="subtitle-view">
      <Typography variant="m" size="subtitle">
        {joinedParts}
      </Typography>
      {typeof fract === 'string' && parseFloat(fract) > 0 && (
        <>
          <span className={comma}>,</span>
          <Typography variant="m" size="body_accent">
            {fract}
          </Typography>
        </>
      )}
      <Typography className={subtitleViewCurrency} variant="caption_accent">
        {currency}&#x200A;
      </Typography>
      <Typography variant="caption_accent">&#x200A;{unit}</Typography>
    </div>
  );
};
